import React from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';

import Typography from '@ts-core/components/Typography';

import StudentSelectorListItem from './StudentSelectorListItem';

const StudentsSelectorList = (props) => {
  const { students, isStudentSelected, onToggleStudent } = props;

  if (!students.length) {
    return <Typography variant="body2">No se encontraron estudiantes.</Typography>;
  }

  return (
    <List disablePadding>
      {students.map((student, index) => (
        <StudentSelectorListItem key={index} student={student} selected={isStudentSelected(student)} onToggle={onToggleStudent} />
      ))}
    </List>
  );
};

StudentsSelectorList.propTypes = {
  students: PropTypes.array,
  isStudentSelected: PropTypes.func.isRequired,

  onToggleStudent: PropTypes.func.isRequired,
};

StudentsSelectorList.defaultProps = {
  students: [],
};

export default StudentsSelectorList;
